module.exports = __webpack_public_path__ + "static/media/Banner-Controle-1920x300-LP.c5820661.png";